import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment'
import { ColetorCustos } from '../_models/ColetorCustos';
import { PagOdsCencst } from '../_models/PagOdsCencst';
import { PagOdsOrdint } from '../_models/PagOdsOrdint';
import { RateioDespesas } from '../_models';

@Injectable({
    providedIn: 'root'
})

export class ColetorCustosService {

    ObterColetoresCusto(codColetorCusto: string, nomeTipoColetor: string, codEmpresa: string, divisao: string, numCaixa: string, processo: string, numOperacao: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}/api/ColetorCusto`;

        const body = {
            codColetorCusto: codColetorCusto,
            nomeTipoColetor: nomeTipoColetor,
            codEmpresa: codEmpresa,
            divisao: divisao,
            numCaixa: numCaixa,
            processo: processo,
            numOperacao: numOperacao
        };

        return this.http.post<ColetorCustos[]>(apiUrl, body);
    }

    validateColetoresCustos(coletores: RateioDespesas[], codEmpresa: string, divisao: string, numCaixa: string, processo: string): Observable<any> {
        let apiUrl = `${environment.apiUrl}/api/ColetorCusto/valida`;

        const body = {
            codEmpresa: codEmpresa,
            divisao: divisao,
            numCaixa: numCaixa,
            processo: processo,
            rateios: coletores
        }

        return this.http.post<any[]>(apiUrl, body);
    }

    ValidarColetoresEmpresa(coletores: RateioDespesas[], codEmpresa: string, divisao: string): Observable<any> {
        let apiUrl = `${environment.apiUrl}/api/ColetorCusto/validaempresa`;

        const body = {
            codEmpresa: codEmpresa,
            divisao: divisao,
            rateios: coletores
        }

        return this.http.post<any[]>(apiUrl, body);
    }

    ObterColetoresCentroCusto(descriao: string, empresa: string, divisao: string): Observable<any> {
        let apiUrl = `${environment.apiUrl}/api/ColetorCusto/centrocusto`;

        if (descriao == '')
            descriao = 'NULL'
        if (empresa == '')
            empresa = 'NULL'
        if (divisao == '')
            divisao = 'NULL'

         const body = {
            descriao: descriao,
            empresa: empresa,
            divisao: divisao
        }

        return this.http.post<PagOdsCencst[]>(apiUrl,body);
    }

    ObterColetoresOrdemInterna(tipoColetor: string, descriao: string, empresa: string, divisao: string): Observable<any> {
        let apiUrl = `${environment.apiUrl}/api/ColetorCusto/ordeminterna`;

        if (descriao == '')
            descriao = 'NULL'
        if (empresa == '')
            empresa = 'NULL'
        if (divisao == '')
            divisao = 'NULL'
            
        const body = {
            tipoColetor: tipoColetor,
            descriao: descriao,
            empresa: empresa,
            divisao: divisao
        }

        return this.http.post<PagOdsOrdint[]>(apiUrl, body);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }
}
